/**
 * @generated SignedSource<<2f3097512e45d7d8a062b1a0f75fc29e>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SystemMessagesScreenQuery$variables = Record<PropertyKey, never>;
export type SystemMessagesScreenQuery$data = {
  readonly currentUser: {
    readonly " $fragmentSpreads": FragmentRefs<"SystemMessagesView_user">;
  } | null | undefined;
};
export type SystemMessagesScreenQuery = {
  response: SystemMessagesScreenQuery$data;
  variables: SystemMessagesScreenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 20
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "SystemMessagesScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SystemMessagesView_user"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "SystemMessagesScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v0/*:: as any*/),
            "concreteType": "MessageConnection",
            "kind": "LinkedField",
            "name": "systemMessages",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "MessageEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Message",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "body",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "createdAt",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "rowId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "title",
                        "storageKey": null
                      },
                      (v1/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cursor",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endCursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasNextPage",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "systemMessages(first:20)"
          },
          {
            "alias": null,
            "args": (v0/*:: as any*/),
            "filters": null,
            "handle": "connection",
            "key": "SystemMessagesView_user_systemMessages",
            "kind": "LinkedHandle",
            "name": "systemMessages"
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "unviewedSystemMessagesCount",
            "storageKey": null
          },
          (v1/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "4b8ab9868f9bde45cb1872b4a4ecd416",
    "id": null,
    "metadata": {},
    "name": "SystemMessagesScreenQuery",
    "operationKind": "query",
    "text": "query SystemMessagesScreenQuery {\n  currentUser {\n    ...SystemMessagesView_user\n    id\n  }\n}\n\nfragment SystemMessagesView_user on User {\n  systemMessages(first: 20) {\n    edges {\n      node {\n        body\n        createdAt\n        rowId\n        title\n        id\n        __typename\n      }\n      cursor\n    }\n    totalCount\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  unviewedSystemMessagesCount\n  id\n}\n"
  }
};
})();

(node as any).hash = "37ee56311059fe08dacf64ecb4448871";

export default node;
